import {ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ApiService} from "../../../../services/api.service";
import {Vapor} from "../../../Vapor";
import {environment} from "../../../../../environments/environment";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-large-file-uploader',
  templateUrl: './large-file-uploader.component.html',
  styleUrls: ['./large-file-uploader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LargeFileUploader),
      multi: true
    }
  ]
})
export class LargeFileUploader implements OnInit, ControlValueAccessor {

  @Input() readOnly: boolean = false;
  @Input() type: 'document' | 'image' | 'media';
  @Input() uploaderStyle: 'dropzone' | 'input' = 'dropzone';
  @Input() message: string;
  @Input() path: string = '';

  value: string[] = [];

  $uploading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  onChange: any = () => {}
  onTouch: any = () => {}

  constructor(public api: ApiService, public ref: ChangeDetectorRef, public vapor: Vapor) { }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: string[]): void {
    if(obj){
      this.value = obj;
    }
  }

  handleChange(data: any){


  }

  removeFile(index: number){
    this.value.splice(index,1);
    this.ref.detectChanges();
    this.onChange(this.value);
  }

  onFileInput(data: any){

    const reader = new FileReader();
    if(data.target.files && data.target.files.length) {
      const [file] = data.target.files;

      this.vapor.store(file, {
        signedStorageUrl: environment.host_domain + '/api/core/file-upload',
        visibility: 'public-read'
      }).then((StoreResult: any)=>{
        // NOW WE HAVE IT IN S3 LETS FIND A HOME FOR IT
        this.vapor.acknowledge(StoreResult.key, this.path).then((res: any)=>{
          // WE SHOULD HAVE THE FINAL URL OF THE OBJECT NOW
          this.value = [res.Url];
          this.ref.detectChanges();
          this.onChange(this.value);
          this.$uploading.next(false);
        })

      });

    }
  }


  uploadFile = (item: any): any => {

    this.$uploading.next(true);
    this.vapor.store(item.file, {
      signedStorageUrl: environment.host_domain + '/api/core/file-upload',
      visibility: 'public-read'
    }).then((StoreResult: any)=>{
      // NOW WE HAVE IT IN S3 LETS FIND A HOME FOR IT
      this.vapor.acknowledge(StoreResult.key, this.path).then((res: any)=>{
        // WE SHOULD HAVE THE FINAL URL OF THE OBJECT NOW
        this.value.push(res.Url);
        this.ref.detectChanges();
        this.onChange(this.value);
        this.$uploading.next(false);
      })

    });

  }

  isImage(data: string){

    const dataitem = data.split('.');
    const item = dataitem[dataitem.length - 1];

    return !(
      item === 'mp4' ||
      item === 'avi' ||
      item === 'mov' ||
      item === 'webm' ||
      item === 'asf' ||
      item === '3gp' ||
      item === 'm4v'
    );


  }

}
